// module
import React from 'react';

// img
import logo from '../img/logo_C.PNG';

class Header extends React.Component{
    render() {
        return(
            <div className="header">
                <div className="logo_img">
                    <img src={logo} alt="error"/>
                </div>
                <div className="header_title">
                    GAAP : a genome assembly + annotation pipeline
                </div>
            </div>
        );
    }
}

export default Header;